import type {
  SprintListItem,
  SprintListItemApiResponse,
  SprintSummaryDetails,
  SprintSummaryDetailsApiResponse,
} from 'src/types/sprint';

export const mapSprintSummaryDetails = (
  sprint?: SprintSummaryDetailsApiResponse | null,
): SprintSummaryDetails | undefined => {
  if (!sprint) {
    return undefined;
  }

  const { _id, ...sprintWithoutId } = sprint;

  return {
    ...sprintWithoutId,
    id: _id,
  };
};

export const mapSprintListItem = (
  sprint: SprintListItemApiResponse,
): SprintListItem => {
  const { _id, ...sprintWithoutId } = sprint;

  return {
    ...sprintWithoutId,
    id: _id,
  };
};

/** Keep the internal revamp pilot separate from legacy sprint availability. */
export const canUseSprintWorkspace = (
  revampExperience: boolean,
  sprintWorkspaceEnabled?: boolean,
): boolean => !revampExperience || Boolean(sprintWorkspaceEnabled);
